import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetViewDocumentHTMLRequest,
  GetViewDocumentHTMLResponse,
} from "../../models/DocumentEditing.model";
import {
  GetTagsValuesRequest,
  GetTagsValuesResponse,
} from "../../models/TagValue.model";

const API_URL = environment.apiUrl;

// ============================================================
// שליפת תבנית HTML גולמית (עם {{tags}})
// ============================================================

export const getTemplateHtml = createAsyncThunk<
  GetViewDocumentHTMLResponse,
  GetViewDocumentHTMLRequest,
  { rejectValue: string }
>(
  "documentEditing/getTemplateHtml",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}Document/GetViewDocumentHTML`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(request),
        },
      );

      if (!response.ok) {
        return rejectWithValue(`שגיאת שרת: ${response.status}`);
      }

      const data: GetViewDocumentHTMLResponse = await response.json();

      if (!data.success) {
        return rejectWithValue(data.message || "שגיאה בקבלת תבנית HTML");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "שגיאה בחיבור לשרת");
    }
  },
);

// ============================================================
// שליפת ערכי {{tags}} — key-value pairs
// ============================================================

export const getTagsValues = createAsyncThunk<
  GetTagsValuesResponse,
  GetTagsValuesRequest,
  { rejectValue: string }
>(
  "documentEditing/getTagsValues",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}TagValue/GetTagsValues`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        return rejectWithValue(`שגיאת שרת: ${response.status}`);
      }

      const data: GetTagsValuesResponse = await response.json();

      if (!data.success) {
        return rejectWithValue(data.message || "שגיאה בקבלת ערכי תגיות");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "שגיאה בחיבור לשרת");
    }
  },
);
